<!--
 * @Descripttion: 全局引用 写在这里
 * @version: 
 * @Author: pengmiaopei
 * @Date: 2021-10-09 10:59:41
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-12-27 14:28:36
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\components\Global.vue
-->
<script>
  const flowUrl = 'http://39.96.26.68:7722'
  export default {
    flowUrl, //设计管理平台的 url
  }
</script>
